//
import BranchOfficeModel from '@/models/General/GBranchOffice'
import ProductModel from '@/models/Warehouse/WhProduct'
import FamilyModel from '@/models/Warehouse/WhFamily'
import SubfamilyModel from '@/models/Warehouse/WhSubfamily'
import TagModel from '@/models/Warehouse/WhTag'

//
export default [
    {
        flex: {
            xs12: true,
            sm4: true,
            md3: true,
        },
        name: 'g_branch_office_id',
        props: {
            hideDetails: true,
            itemText: 'name',
            itemValue: 'id',
            label: 'Sucursal',
            model: BranchOfficeModel,
            noObject: true,
            paramSearch: 'address',
        },
        type: 'autocomplete',
        value: '',
    },
    {
        flex: {
            xs12: true,
            sm4: true,
            md3: true,
        },
        name: 'wh_product_id',
        props: {
            hideDetails: true,
            itemText: 'name',
            itemValue: 'id',
            label: 'Producto',
            model: ProductModel,
            noObject: true,
            paramSearch: 'alias_name',
        },
        type: 'autocomplete',
        value: '',
    },
    {
        flex: {
            xs12: true,
            sm4: true,
            md3: true,
        },
        name: 'is_active',
        props: {
            chips: true,
            clearable: true,
            hideDetails: true,
            items: [
                {
                    text: 'Si',
                    value: 'true',
                },
                {
                    text: 'No',
                    value: 'false',
                },
            ],
            itemText: 'text',
            itemValue: 'value',
            label: 'Activo',
        },
        type: 'select',
        value: '',
    },
    {
        flex: {
            xs12: true,
            sm4: true,
            md3: true,
        },
        name: 'upc_code',
        props: {
            hideDetails: true,
            label: 'Código UPC',
        },
        type: 'text',
        value: '',
    },
    {
        flex: {
            xs12: true,
            sm4: true,
            md3: true,
        },
        name: 'starts_after_or_equals',
        props: {
            hideDetails: true,
            label: 'Fecha de inicio',
        },
        type: 'date',
        value: '',
    },
    {
        flex: {
            xs12: true,
            sm4: true,
            md3: true,
        },
        name: 'ends_before_or_equals',
        props: {
            hideDetails: true,
            label: 'Fecha de termino',
        },
        type: 'date',
        value: '',
    },
    {
        flex: {
            xs12: true,
            sm4: true,
            md3: true,
        },
        name: 'wh_family_id',
        props: {
            hideDetails: true,
            itemText: 'family',
            itemValue: 'id',
            label: 'Familia',
            model: FamilyModel,
            noObject: true,
            paramSearch: 'search',
        },
        type: 'autocomplete',
        value: '',
    },
    {
        flex: {
            xs12: true,
            sm4: true,
            md3: true,
        },
        name: 'wh_subfamily_id',
        props: {
            hideDetails: true,
            itemText: 'subfamily',
            itemValue: 'id',
            label: 'Subfamilia',
            model: SubfamilyModel,
            noObject: true,
            paramSearch: 'subfamily',
        },
        type: 'autocomplete',
        value: '',
    },
    {
        flex: {
            xs12: true,
            sm4: true,
            md3: true,
        },
        name: 'tags_id',
        props: {
            hideDetails: true,
            itemText: 'tag',
            itemValue: 'id',
            label: 'Etiqueta',
            model: TagModel,
            noObject: true,
            paramSearch: 'search',
        },
        type: 'autocomplete',
        value: '',
    },
]